module.exports = __webpack_public_path__ + "static/img/ug.1f14e988.svg";